module.exports = "<div class=\"<%= gwPaQuickQuoteMap %>\" id=\"{{$ctrl.mapName || 'googleMapsComponent'}}\"></div>\n"